import { useState, useEffect } from "react";
import TestimonialBox from "./TestimonialBox";

function TestimonialBoxes() {
  const [active, setActive] = useState(0);

  const testimonials = [
    {
      text: " “Ak Fitness has completely transformed my perspective on health. The atmosphere is electric and the trainers are top-notch. Truly the best facility in the region!”",
      name: "Rahul Varma",
      job: "Gym Member",
    },
    {
      text: " “As a trainer, I appreciate the modern equipment and the supportive community here. It's a privilege to work in such a motivating environment every day.”",
      name: "Megha Singh",
      job: "Yoga Trainer",
    },
    {
      text: " “The sessions here are intense and the results are visible. Joining AK Fitness was the best decision I made for my health and discipline.”",
      name: "Vikram Singh",
      job: "Gym Member",
    },
    {
      text: " “Friendly atmosphere and world-class equipment. I love the morning power yoga sessions; they give me a great start to the day.”",
      name: "Sunita Reddy",
      job: "Yoga Member",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div className="relative w-full h-full">
      {testimonials.map((t, i) => (
        <TestimonialBox
          key={i}
          text={t.text}
          name={t.name}
          job={t.job}
          active={i === active}
        />
      ))}
    </div>
  );
}

export default TestimonialBoxes;
